import { Component, OnInit   } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ILinksAyuda, DTOLinksAyuda } from './../../models/login.models'
import { AuthService } from '../../services/components/auth.servicice';
import { Router } from '@angular/router';
import { HeaderAuthComponent } from '../../shared/components/header_auth/header_auth.component';
import { environment } from '../../../environments/environment';

declare let gtag: Function;

@Component({
  selector: 'app-principal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, HeaderAuthComponent],
  templateUrl: './principal.component.html',
  styleUrl: './principal.component.scss'
})

export class PrincipalComponent implements OnInit {

  showViewHTMLComponent = false;
  linksAyuda: ILinksAyuda = DTOLinksAyuda;
  nameUser = "";
  urlPreguntasFrec = "";
  urlCalendario = "";
  urlRecaudoAno = "";
  urlNoticias = "";

  urlsPaso  = {
    uno: this.getAssetUrl('assets/step/imagen-step1.png'),
    dos: this.getAssetUrl('assets/step/imagen-step2.png'),
    tres: this.getAssetUrl('assets/step/imagen-step3.png') 
  }

  constructor(private router: Router,
    private authService: AuthService) {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/login']);
      return;
    } else {
      this.showViewHTMLComponent = true;
    }
    this.nameUser = String(this.authService.getNameUser());
    
    const config = this.authService.getValueConfig();

    this.urlPreguntasFrec = environment.urlPreguntasFrec;
    this.urlCalendario = environment.urlCalendario;
    this.urlRecaudoAno = environment.urlRecaudoAno;
    this.urlNoticias = environment.urlNoticias;

  }

  ngOnInit() {
    try {
      window.scrollTo(0, 0);
    } catch (error) {
      console.error(error);
    }

    if (typeof gtag === 'function') {
      try {
        gtag('event', 'page_view', { page_path: '/OficinaVirtualSIT2/principal' });
      } catch (err) {}
    }
  }

  getAssetUrl(filename: string): string {
    return `${filename}?v=${Date.now()}`;
  }

  openWindowTarget(url:string){
    window.open(url, "_blank")
  }

  getCerPag(){
    const user = this.authService.getValueUser();
    const config = this.authService.getValueConfig();
    const url: string = config.urlCertificadoRIT + "par1=" + user.tipoIdN + "&par2=" + user.nroId;
    window.open( url );
  }
}
